import React from 'react'
import styled from 'styled-components'
import Tooltip from '../Tooltip'

const InputArea = ({
  dataTip,
  dataFor,
  endAdornment,
  disabled,
  onChange,
  placeholder,
  startAdornment,
  value,
  tooltip,
}) => {
  return (
    <StyledInputWrapper dataTip={dataTip} dataFor={dataFor}>
      {!!startAdornment && startAdornment}
      {tooltip ? <Tooltip text={tooltip} /> : <></>}
      <StyledInput
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={onChange}
        autocomplete="off"
        rows={50}
      />
      {!!endAdornment && endAdornment}
    </StyledInputWrapper>
  )
}

const StyledInputWrapper = styled.div.attrs(({ dataTip, dataFor }) => ({
  'data-tip': dataTip,
  'data-for': dataFor,
}))`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
  font-size: 18px;
  font-weight: bold;
  color: ${(props) => props.theme.color.grey[600]};
`

const StyledInput = styled.textarea`
  background-color: ${(props) => props.theme.color.grey[200]};
  border-radius: ${(props) => props.theme.borderRadius}px;
  box-shadow: inset 4px 4px 8px ${(props) => props.theme.color.grey[300]},
    inset -6px -6px 12px ${(props) => props.theme.color.grey[100]};
  border: 0;
  color: ${(props) => props.theme.color.grey[600]};
  font-size: 18px;
  flex: 1;
  height: 250px;
  margin-right: 10px;
  margin-left: 20px;
  padding-left: 10px;
  outline: none;
  width: 200px;
  max-width: 100%;
`

export default InputArea
